import { LightningElement, api } from "lwc";

let uid = 0;
class tab extends LightningElement {
  @api label = null;
  @api value = null;
  loaded = false;

  @api load() {
    this.loaded = true;
  }

  @api unload() {
    this.loaded = false;
  }

  connectedCallback() {
    this.dispatchEvent(
      new CustomEvent("privatetabregister", {
        cancelable: true,
        bubbles: true,
        composed: true,
        detail: {
          label: this.label,
          title: this.title || this.label,
          value: this.value || `tab-${uid++}`,
          load: () => this.load(),
          unload: () => this.unload(),
        },
      })
    );
  }
}

export default tab;
